<template>
  <div class="advantage-component">
    <div class="area">
      <div class="row advantage-container" v-animated-show="utils.handleScroll">
        <div class="float-art-left-md"></div>
        <section class="main-desc col-4 col-md-12 gap-offset">
          <Description
            class="main default"
            ref="mainDescription"
            :title="title"
            :desc="desc"
            href="/contacts"
          />
        </section>
        <section
          class="list-section-banner col-md-12"
          :class="[
            'block-' + (i + 1),
            {
              'gap-offset': i == 0,
              'col-5': l.art,
              'col-4': l.title && l.desc,
            },
          ]"
          v-for="(l, i) in list"
          :key="i"
        >
          <div class="content">
            <Description
              class="mini icon-top"
              ref="bannerDescription"
              :title="l.title"
              :desc="l.desc"
              :list="l.list"
              :button="l.button"
              href="/contacts"
              :icon="l.icon"
              v-if="l.title && l.desc"
            />

            <div class="art" v-if="l.art">
              <img
                class="img"
                v-if="l.art.img.src"
                :src="l.art.img.src"
                :alt="l.art.img.alt"
              />
              <img
                class="float-img"
                v-if="l.art.float_img.src"
                :src="l.art.float_img.src"
                :alt="l.art.float_img.alt"
              />
            </div>
          </div>

          <div class="float-art-right" v-if="i == 0"></div>
          <div class="float-art-right2" v-if="i == 3"></div>
          <div class="float-art-left" v-if="i == 1"></div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Advantage",
  props: {
    title: String,
    desc: String,
    theme: {
      default: "default",
    },
    list: Array,
  },
  data() {
    return { utils: utils };
  },
};
</script>

<style lang="scss">
.advantage-component {
  position: relative;
  z-index: 1;
  @extend %page-block;
  padding-bottom: 0;
  @media all and (max-width: $md) {
    padding-top: 168px;
    padding-bottom: 88px;
  }
  .row {
    grid-row-gap: 28px;
    &.advantage-container {
      position: relative;
      @media all and (max-width: $md) {
        grid-row-gap: 28px;
      }
    }
  }
  .button-description {
    @extend %text-big;
    width: 186px;
  }
  .dotted {
    @media all and (max-width: $md) {
      margin: 5px 0;
    }
  }
  .main-desc {
    position: relative;
    z-index: 1;
    @media all and (max-width: $md) {
      grid-column: 1 / span 8;
    }
    grid-column: 2 / span 4;
    .description.default {
      .desc {
        @media all and (max-width: $md) {
          font-size: 12px;
        }
      }
    }
  }
  .block-1 {
    @media all and (max-width: $md) {
      grid-column: 1 / span 10;
      margin: 0;
    }
    margin-left: -26px;
    margin-right: -26px;
    grid-column: 8 / span 3;
  }
  .block-2 {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      margin: 0;
    }
    grid-column: 3 / span 4;
  }
  .block-3 {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      margin: 0;
    }
    grid-column: 8 / span 4;
  }
  .block-4 {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      margin: 0;
    }
    grid-column: 7 / span 4;
  }
  .block-5 {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      margin: 0;
      padding-bottom: 0;
    }
    grid-column: 2 / span 4;
    grid-row: 3;
    padding-bottom: 80px;
    .float-img {
      @media all and (max-width: $md) {
        left: unset;
        right: -20px;
      }
      left: -50%;
    }
  }
  .art {
    @media all and (max-width: $md) {
      margin: 0;
    }
    margin-left: -26px;
    margin-right: -26px;
    position: relative;
    .img {
      width: 100%;
      border-radius: 10px;
    }
    .float-img {
      @media all and (max-width: $md) {
        left: unset;
        right: -20px;
        max-height: 226px;
        max-width: 346px;
        width: 70%;
        object-fit: contain;
      }
      position: absolute;
      right: -130px;
      bottom: -100px;
      height: 226px;
      width: 346px;
    }
  }
  .float-art-left,
  .float-art-left-md {
    @media all and (max-width: $md) {
      display: none;
    }
    position: absolute;
    background: url(../assets/photos/history/rozh1_1@2x.png) no-repeat right
      center;
    max-width: 600px;
    max-height: 600px;
    left: calc((1088px - 100vw) / 2 - 230px);
    width: calc((100vw - 1088px) / 3 + 240px);
    height: calc((100vw - 1088px) / 3 + 240px);
    background-size: contain;
    top: 0;
  }
  .float-art-left-md {
    @media all and (max-width: $md) {
      display: block;
      width: 234px;
      height: 251px;
      top: -206px;
      left: -92px;
    }
    max-width: 600px;
    max-height: 600px;
    display: none;
  }
  .float-art-right {
    pointer-events: none;
    max-width: 600px;
    max-height: 600px;
    @media all and (max-width: $md) {
      background: url(../assets/photos/main/float-art-right.png) no-repeat right;
      grid-column: 1 / span 12;
      right: -120px;
      transform: translate(40%);
      top: -260%;
      width: 486px;
      height: 415px;
      z-index: -1;
    }
    @media all and (max-width: $sm) {
      right: -96px;
      z-index: -1;
    }
    position: absolute;
    background: url(../assets/photos/main/bread_1@2x.png) no-repeat right center;
    right: calc((1088px - 100vw) / 2 - 350px);
    width: calc((100vw - 1088px) / 3 + 540px);
    height: calc((100vw - 1088px) / 3 + 540px);
    background-size: contain;
    top: calc(((1088px - 100vw) / 3 - 340px) / 2);
  }
  .float-art-right2 {
    max-width: 600px;
    max-height: 600px;
    pointer-events: none;
    @media all and (max-width: $lg) {
      grid-column: 1 / span 12;
      right: calc((1088px - 100vw) / 2 - 280px);
    }
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
      right: 20px;
      transform: translate(40%) rotate(-20deg);
      top: 81%;
      width: 383px;
      height: 383px;
    }
    @media all and (max-width: $sm) {
      right: -75px;
    }
    position: absolute;
    background: url(../assets/photos/contacts/rozh@2x.png) no-repeat right
      center;
    transform: translateX(00px);
    right: calc((1088px - 100vw) / 2 - 280px);
    width: calc((100vw - 1088px) / 3 + 240px);
    height: calc((100vw - 1088px) / 3 + 240px);
    background-size: contain;
    top: calc(((1088px - 100vw) / 3 + 140px) / 2);
  }
  .list-section-banner {
    position: relative;
    .description-content {
      .desc {
        margin-top: -11px;
        line-height: 1.33em;
      }
    }
  }
}
</style>
